import cookies from 'js-cookie'
import * as tjStorage from '@common-libs/tj-storage'


let cookieConfig = {
  tujiaUtm: 'tujia_utm',
  outcode: 'outcode'
}

function getTujiaUtm() {
  return cookies.get(cookieConfig.tujiaUtm)
}

function getClientDeviceId() {
  return cookies.get(cookieConfig.clientDeviceId)
}

/**
 * 获取 outcode
 */
function getOutcode() {
  return cookies.get(cookieConfig.outcode)
}

export default {
  ...tjStorage,
  getTujiaUtm,
  getClientDeviceId,
  getOutcode
}
